import React from 'react'

class ShowSelect extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			selectedShowId: ''
		}
	}

	handleChange(e){
		this.setState({ selectedShowId: e.target.value })
	}

	render() {
		return (
			<select className="show_id" value={this.props.selectedShowId} onChange={this.handleChange.bind(this)}>
				<option value="-1">Select Show...</option>
				{this.props.shows.map( show => <option key={show.id} value={show.id}>{decodeURIComponent(show.title)}</option> )}
			</select>
		)
	}
}

export default ShowSelect



// WEBPACK FOOTER //
// ./src/components/show_select.js